import { Typography, Separator } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";

interface PreviewShellProps {
  children: React.ReactNode;
}

const PreviewShell = ({ children }: PreviewShellProps) => (
  <Stack direction="column" className="al-h-screen al-rounded-lg al-bg-background al-p-6 al-overflow-hidden">
    <div className="al-mb-4">
      <Typography variant="body" weight="medium">
        Preview
      </Typography>
      <Typography variant="body" size="xs" className="al-text-gray-500 al-mt-1">
        This is how your subscription will look when delivered
      </Typography>
    </div>
    <Separator className="al-mb-6" />
    {children}
  </Stack>
);

export default PreviewShell;
